import { SlugNameService } from './../../Services/slug-name.service';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { ToastaService, ToastOptions } from "ngx-toasta";
import { CheckoutService } from "src/app/Services/checkout.service";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { HomePageService } from "src/app/Services/home-page.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

import { TranslateService } from "@ngx-translate/core";
import { MetaService } from "src/app/Services/meta-data.service";

@Component({
    selector: "app-favorites",
    templateUrl: "./favorites.component.html",
    styleUrls: ["./favorites.component.scss"],
})
export class FavoritesComponent implements OnInit, OnDestroy {
    loading: boolean = false;
    favoritesList: any[] = [];
    lang: any;
    isAuthUser: any;
    cartList: Array<any>;
    environmentVariables: any;
    redirectToProduct: boolean = false;
    loadingFav: boolean = true;
    homeSubscription: any;

    constructor(
        public embryoService: EmbryoService,
        private translate: TranslateService,
        private checkoutService: CheckoutService,
        private toastyService: ToastaService,
        public userLoginServies: LoginUsersService,
        private router: Router,
        public HomeService: HomePageService,
        private confgServ: StaticPagesService,
        private metaService: MetaService,
				private slugNameService:SlugNameService,
    ) {
        this.cartList = [];
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.redirectToProduct =
                this.environmentVariables?.PRODUCT_TYPE == "main";
        });
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
            if (this.lang == "en")
                this.metaService.setTitle(
                    `Favorites - ${this.environmentVariables?.APP_NAME}`
                );
            else
                this.metaService.setTitle(
                    `المفضله - ${this.environmentVariables?.APP_NAME_AR}`
                );
        });
    }

    ngOnInit() {
        this.homeSubscription = this.HomeService.isInitLoading.subscribe(
            (value) => {
                if (value) {
                    this.loading = true;
                } else {
                    this.loading = false;
                }
            }
        );
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        this.lang = localStorage.getItem("lang");
        this.translate.setDefaultLang(this.lang);
        this.getFavorites();
        this.getCartData();
    }

    ngOnDestroy() {
        this.homeSubscription?.unsubscribe();
    }

    getFavorites() {
        this.loadingFav = true;
        this.embryoService.favouritesListSub.subscribe((res) => {
            if (res.length > 0) this.loadingFav = false;
            else {
                setTimeout(() => {
                    this.loadingFav = false;
                }, 2000);
            }
            this.favoritesList = res;
            this.favoritesList.forEach((product: any) => {
                product.routingName = encodeURIComponent(
                    product.name.replace(/\s/g, "-")
                );
                product.slug_name = this.getProductName(product);
            });
        });
    }

    getCartData() {
        this.embryoService.productCartSub.subscribe((res) => {
            if (Array.isArray(res)) {
                this.cartList = res;
            }
        });
    }

    openConfirmationPopup(product: any, index: number | null = null) {
        this.unFavourite(product, index);
    }

    unFavourite(product: any, idx: number | null = null) {
        product["loading"] = true;
        const index =
            idx ||
            this.favoritesList.findIndex((item: any) => item.id === product.id);
        this.removeMsg();
        if (this.isAuthUser) {
            this.HomeService.removeFromFavList(product.id).subscribe(
                (res: any) => {
                    product["loading"] = false;
                    if (res.code === 200) {
                        this.favoritesList.splice(index, 1);
                        this.embryoService.favouritesListSub.next(
                            this.favoritesList
                        );
                    }
                }
            );
        } else {
            product["loading"] = false;
            this.favoritesList.splice(index, 1);
            this.embryoService.favouritesListSub.next(this.favoritesList);
        }
    }

    removeMsg() {
        const toastOption: ToastOptions = {
            title: "Remove product from wishlist",
            msg: "Product removing from wishlist",
            showClose: true,
            timeout: 1000,
            theme: "material",
        };
        if (this.lang === "en") {
            toastOption.title = "Remove product from wishlist";
            toastOption.msg = "Product removing from wishlist";
        } else {
            toastOption.title = "تتم الان ازالة المنتج من المفضلة";
            toastOption.msg = "لقد قمت بازالة هذا المنتج من قائمة المفضلة";
        }

        this.toastyService.wait(toastOption);
    }

    getNameRouting(product: any) {
        if (!product?.active) {
            this.router.navigate(["/" + this.lang + "/not-available"]);
        } else {
            const nameRouting = encodeURIComponent(product.name).replace(
                /\s/g,
                "-"
            );
            const parentId = product.parent_id || product.id;
            this.router.navigate(
                ["/" + this.lang + "/products",  product?.slug],
                // {
                //     state: { name: nameRouting },
                //     queryParams: { variant: product.id },
                // }
            );
        }
    }
    getProductName(product: any) {
        // const nameRouting = product.name_en
        //     .replace(/[^\w\s]/gi, "-")
        //     .replace(/ /g, "-");
        // const parentId = product.parent_id || product.id;
        // return nameRouting + "/" + parentId;
				return this.slugNameService.getProductName(product);
    }
		
		redirectToProductFun(product:any){
			const parentId = product?.parent_id || product?.id;
			if (product?.slug) {
				this.router.navigate(
					["/" + this.lang + "/products", product?.slug ],
					// {
					// 		state: { name: product?.slug },
					// 		queryParams: { variant: product.id },
					// }
				);
			}
			else{
				const nameRouting = product.name_en
					.replace(/[^\w\s]/gi, "-")
					.replace(/ /g, "-");
					this.router.navigate(
						["/" + this.lang + "/products", product?.slug],
						// {
						// 		state: { name: nameRouting },
						// 		queryParams: { variant: product.id },
						// }
					);
			}
		}
}
